<template>
  <div>
    <div class="app-header">
      <img :alt="$config.client.name" :src="logoPath"/>
    </div>
    <div class="center">
      <b-container class="msg" v-if="status">
        <p>
          {{ $t('validationEmail.message') }}
        </p>
        <b-button
          type="button"
          variant="outline-primary"
          data-test="validationEmail-signIn"
          @click.prevent="$router.push({ name: 'SignIn' })"
        >
          {{ $t('validationEmail.goToLogin') }}
        </b-button>
      </b-container>
      <b-container class="msg" v-else>
        <p>
          {{ $t('validationEmail.error') }}
        </p>
      </b-container>
    </div>
    <small class="footer">
      <p>{{ $t('footer') }} <a href="https://www.neogeo.fr/" target="_blank" rel="noopener">Neogeo-Technologies</a></p>
    </small>
  </div>
</template>

<script>

import loginAPI from '@/api/loginAPI.js';

export default {
  name: 'ValidationEmail',
  data: () => {
    return {
      status: undefined
    };
  },
  computed: {
    logoPath() {
      return require(process.env.VUE_APP_LOGO);
    }
  },
  created() {
    this.postToken(this.$route.query.token);
  },
  methods: {
    async postToken(token) {
      const data = { token: token };
      try {
        const result = await loginAPI.newEmailConfirm(data);
        this.status = (result === true);
      } catch (err) {
        this.status = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>

.center {
  position: initial;
}

.center .msg.container {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.center .msg.container,
.center .msg.container button {
  font-size: large;
}

.footer {
  position: absolute;
  bottom: 0;
  font-size: small;
}

.footer a {
  text-decoration: none;
}
</style>
